import React from 'react';
import { connect } from 'react-redux';
import axios from "axios";
import {config} from "../../app/config";
import {ListenButton} from './main/ListenButton';
import '../../styles/screens/main.scss';
import TranslationService from "../../app/services/TranslationService";
import { preloaderShow, preloaderHide, say, alert, topbarUpdate } from "../../actions";
import {WelcomeScreen} from "./main/WelcomeScreen";
import {TalkScreen} from "./main/TalkScreen";
import {Button} from "../icymat-design/Button";
import {HistoryPanel} from "./main/HistoryPanel";
import {Textarea} from "../icymat-design/Textarea";
import {Listening} from "../preloaders/Listening";


const minTextareaHeight = 38;

export class MainClass extends React.Component {

    /**
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            info: [],
            queryText: '',
            queryTextHeight: minTextareaHeight,
            query: '',
            thinking: false,
            writing: false,
            interaction: null,
            interactionCounter: null,
            answer: '',
            instruction: null,
            data: null,
            html: null,
            talk: null,
            messages: []
        }
    }

    componentDidMount() {
        let that = this;
        axios.get(config.apiAddress + '/information')
            .then(function (response) {
                that.setState({info: response.data});
            }).catch(function(error) {
            });
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== 'main' && this.props.view === 'main') {
            this.props.topbarUpdate({
                action1: null,
                action2: null,
                actionBig: null
            });
        }
    };

    getStyle() {
        return {
            display: (this.props.user !== null && this.props.user.name !== null) && (this.props.view === 'main' || this.props.view === null) ? 'block' : 'none'
        }
    }

    handleQueryTextChange = (event) => {
        const textarea = event.target;

        const maxHeight = 150;//arseInt(window.getComputedStyle(textarea).maxHeight) || 200;
        let newHeight = Math.min(textarea.scrollHeight, maxHeight);

        if (event.target.value.replaceAll("\n", '') === '' || newHeight < minTextareaHeight) {
            newHeight = minTextareaHeight;
        }

        this.setState({queryText: event.target.value, queryTextHeight: newHeight});
    };

    handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey && this.state.queryText.replaceAll("\n", '') !== '') {
            event.target.blur();
            this.setState({queryText: '', query: this.state.queryText, thinking: true, queryTextHeight: minTextareaHeight});
            this.sendQuery(this.state.queryText);
        }
    };

    sendButtonClick = (event) => {
        if (this.state.queryText.replaceAll("\n", '') !== '') {
            // event.target.blur();
            this.setState({queryText: '', query: this.state.queryText, thinking: true});
            this.sendQuery(this.state.queryText);
        }
    };

    sendQuery = (query) => {
        if (query.replace("\n", '') === '') {
            this.props.say(TranslationService.trans(this.props.language, 'main.actions.query_failed'));

            return;
        }

        let that = this;
        this.setState({answer: '', html: null});

        let queryData = {query: query};
        if (this.state.talk !== null) {
            queryData.talk = this.state.talk;
        }

        let messages = this.state.messages;
        messages.push({
            query: query,
            answer: null,
            html: null,
            instruction: null,
            data: null,
            links: []
        });
        this.setState({messages: messages});

        axios.post(config.apiAddress + '/query?lang=' + TranslationService.getLanguage(this.props.user), queryData)
            .then(function (response) {
                if (that.state.talk === null) {
                    that.setState({talk: response.data.talk})
                }

                messages[messages.length - 1] = {
                    query: that.state.query,
                    answer: response.data.answer,
                    html: response.data.html ?? null,
                    instruction: response.data.instruction ?? null,
                    data: response.data.data ?? null,
                    links: response.data.links ?? []
                };

                that.setState({
                    thinking: false,
                    writing: true,
                    answer: response.data.answer,
                    instruction: response.data.instruction ?? null,
                    data: response.data.data ?? null,
                    html: response.data.html ?? null,
                    links: response.data.links ?? [],
                    messages: messages
                });

                // setTimeout(() => {
                //     that.setState({writing: false});
                // }, 5000);

                that.props.say(response.data.answer);
            }).catch(function(error) {
                messages[messages.length - 1] = {
                    query: that.state.query,
                    answer: TranslationService.trans(that.props.language, 'main.actions.query_failed'),
                    html: null,
                    instruction: null,
                    data: null
                };

                that.setState({thinking: false, query: null, answer: TranslationService.trans(that.props.language, 'main.actions.query_failed'), messages: messages});
                that.props.say(TranslationService.trans(that.props.language, 'main.actions.query_failed'));
            });
    }

    renderInformation = () => {
        let rows = [];

        //normal
        this.state.info.forEach(function(info) {
            let className = 'imd-bg-80-blue imd-text-gray';
            if (info.type === 'success') {
                className = 'imd-bg-80-green imd-text-120-green';
            } else if (info.type === 'danger') {
                className = 'imd-bg-80-red imd-text-120-red';
            } else if (info.type === 'warning') {
                className = 'imd-bg-80-yellow imd-text-gray';
            }

            rows.push(<div className={'imd-notification ' + className}>
                <span dangerouslySetInnerHTML={{__html: info.content}} />
            </div>);
        });

        return rows;
    }

    loadTalk = (talkId, messages) => {
        this.setState({talk: talkId, messages: messages, query: '', answer: '', data: null, html: null});
    }

    reset = () => {
        this.setState({talk: null, messages: [], query: '', answer: '', data: null, html: null});
    }

    startInteraction = (type) => {
        const that = this;

        if (type === 'listen') {
            this.setState({interaction: type, interactionCounter: 15});
            let counterInterval = setInterval(() => {
                const counter = that.state.interactionCounter  -1;
                that.setState({interactionCounter: counter});

                if (counter === 0) {
                    that.setState({interactionCounter: null});
                    clearInterval(counterInterval);
                    that.stopInteraction();
                }
            }, 1000);
        }
    }

    stopInteraction = (type) => {
        this.setState({interaction: null});
    }

    render() {
        return (
            <div className="screen" style={this.getStyle()} id="screen-main">
                {this.renderInformation()}

                <HistoryPanel talk={this.state.talk} load={this.loadTalk} reset={this.reset} />
                <button
                    type="button"
                    className={'new-chat-button'}
                    onClick={() => this.reset()}
                >
                    <span className={"imd-icon imd-icon-chat-plus-in imd-text-contrast"} />
                </button>

                {
                    this.state.talk === null && this.state.query === '' ?
                    <WelcomeScreen
                        thinking={this.state.thinking}
                        query={this.state.query}
                        answer={this.state.answer}
                        html={this.state.html}
                        instruction={this.state.instruction}
                        data={this.state.data}
                    /> :
                        <div style={{maxWidth: '800px', margin: '0 auto'}}>
                            <TalkScreen
                                height={'calc(100vh - ' + (180 + 60 * this.state.info.length + (this.state.queryTextHeight - minTextareaHeight)) + 'px)'}
                                messages={this.state.messages}
                                thinking={this.state.thinking}
                                writing={this.state.writing}
                                stopWritingCallback={() => this.setState({writing: false})}
                            />
                        </div>
                }

                <div className={'query-block'}>
                    <div className={'query-block-container imd-bg-blur-120-gray imd-shadow-bottom imd-text-white imd-border-color-default'}>
                        <Textarea
                            silentDisabled={this.state.thinking}
                            placeholder={TranslationService.trans(this.props.language, 'main.how_can_i_help_you')}
                            height={this.state.queryTextHeight + 'px'}
                            value={this.state.queryText}
                            onChange={this.handleQueryTextChange}
                            onKeyDown={this.handleKeyDown}
                        />

                        <div className={'query-buttons'}>
                            <ListenButton
                                listening={this.state.interaction === 'listen'}
                                startInteraction={() => this.startInteraction('listen')}
                                error={(message) => {this.setState({queryText: '', query: '', thinking: false}); this.props.alert(message)}}
                                startCatchTextFromMic={() => this.setState({thinking: true})}
                                catchTextFromMic={(text) => {this.setState({queryText: '', query: text, thinking: true}); this.sendQuery(text);}}
                                lang={this.props.language}
                            />

                            <Button
                                color={'main'}
                                icon={'imd-icon imd-icon-send'}
                                onClick={(event) => this.sendButtonClick(event)}
                            />
                        </div>
                    </div>
                </div>

                <div className={'interaction-screen imd-bg-transparent-black'} style={{display: (this.state.interaction ? 'block' : 'none')}}>
                    <div className={'interaction-container'}>
                        {this.state.interaction === 'listen' ? <Listening /> : null}

                        {this.state.interactionCounter !== null ? (<span className={'imd-text-accent counter'}>{this.state.interactionCounter}&nbsp;s</span>) : null}

                        <Button
                            icon={'imd-icon imd-icon-xmark'}
                            size={'lg'}
                            secondary={true}
                            onClick={() => this.stopInteraction()}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user),
        view: state.view
    }
};

export const MainScreen = connect(mapStateToProps, { preloaderShow, preloaderHide, say, alert, topbarUpdate })(MainClass);
